import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {

}
const qsAll = {
  
}

export const setupProductAdditionals = () => {
  cacheDom(dom, qs, qsAll)
  let swatCounter = 0
  const swatTimer = setInterval(() => {
    if(swatCounter > 30000) clearInterval(swatTimer)

    const swat = window._swat || window.swat
    if (!swat?.evtLayer) return

    clearInterval(swatTimer)

    const events = [
      ['sw:addedtowishlist', 'Added to wishlist', 'Product has been added to the wishlist successfully.'],
      ['sw:removedfromwishlist', 'Removed from wishlist', 'Product has been removed from the wishlist successfully.']
    ]

    events.forEach(([eventName, logLabel, message]) => {
      swat.evtLayer.addEventListener(eventName, (e) => {
        const data = e.detail?.d
        console.log(eventName, logLabel, e)
        
        let selectedButton = null;
        const buttons = document.querySelectorAll(`.product__wishlist--btn[data-product-id="${data?.empi}"][data-variant-id="${data?.epi}"]`);
        buttons.forEach(button => {
          if(!button.classList.contains('!hidden')) {
            selectedButton = button;
            button.setAttribute('aria-label', eventName == 'sw:addedtowishlist' ? 'Remove from Wishlist' : 'Add to Wishlist')
          }
        })
        window.showCustomMessage?.(message, selectedButton)
      })
    })
    swatCounter += 300
  }, 300)
  
}